import { z } from "zod/v4";

export const outboxEventStatusSchema = z.enum(["pending", "published", "dead_lettered"]);

export const outboxEventSchema = z.object({
	id: z.string().uuid(),
	event_type: z.string(),
	aggregate_id: z.string(),
	payload: z.unknown(),
	created_at: z.coerce.date(),
	published_at: z.coerce.date().nullable(),
	attempts: z.number(),
	last_error: z.string().nullable(),
	dead_lettered_at: z.coerce.date().nullable(),
	next_retry_at: z.coerce.date(),
});

export const outboxStatsSchema = z.object({
	pending: z.number(),
	published: z.number(),
	dead_lettered: z.number(),
});

export const retryAllResponseSchema = z.object({
	retried: z.number(),
});

export type OutboxEvent = z.infer<typeof outboxEventSchema>;
export type OutboxEventStatus = z.infer<typeof outboxEventStatusSchema>;
export type OutboxStats = z.infer<typeof outboxStatsSchema>;
